var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/reset"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.68 12.195h.163m-5.474 0H9.5m2.5 0h.18M21 7.555A10.096 10.096 0 0 0 11.961 2C8.001 2 4.651 4.263 3 7.556V3.11m0 13.333A10.096 10.096 0 0 0 12.039 22c3.96 0 7.31-2.263 8.961-5.556v4.445M7.654 8.65C6.74 8.65 6 9.39 6 10.304v3.859c0 .913.74 1.654 1.654 1.654h8.615c.914 0 1.654-.74 1.654-1.654v-3.86c0-.912-.74-1.653-1.654-1.653H7.654Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.cebfc76e1131a17810b20c1ca8bb8185.svg";
export { ForwardRef as ReactComponent };